import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { RpaBotsService } from 'app/rpa-bots/core/rpa-bots.service';
import {
  EUIPathConnActions,
  UIPathConnList,
  UIPathConnListSuccess,
  UpdateUIPathConn,
  UpdateUIPathConnSuccess,
  getCurrentUIPathConn,
  getCurrentUIPathConnSuccess,
  ShowSuccessToast,
  TestUIPathConn,
  TestUIPathConnSuccess
} from 'app/rpa-bots/uipath/store/actions/rpa-uipath-conn.actions';
import { switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { ConstAuthClientCredentials } from '../../common/models/enums';
import { IAppState } from 'app/IAppState';
import { IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';
import { TranslateService } from '@ngx-translate/core';
import { BzgToastService } from 'bz-genome-angular';

@Injectable()
export class UIPathConnEffects {
  getUIPathConnList$ = createEffect(() =>
    this._actions$.pipe(
      ofType<UIPathConnList>(EUIPathConnActions.UIPathConnList),
      switchMap(() => this._rpaBotsService.getConnectionsUiPath()),
      switchMap((connectors: IRpaConnectionUiPath[]) =>
        of(new UIPathConnListSuccess(connectors))
      )
    )
  );
  updateUIPathConn$ = createEffect(() =>
    this._actions$.pipe(
      ofType<UpdateUIPathConn>(EUIPathConnActions.UpdateUIPathConn),
      switchMap(param =>
        this._rpaBotsService.updateConnectionUiPath(param.payload)
      ),
      switchMap(() => [
        new UpdateUIPathConnSuccess(),
        new ShowSuccessToast(),
        new UIPathConnList()
      ]),
      catchError((error, caught) => {
        this._store.dispatch(new UpdateUIPathConnSuccess());
        return caught;
      })
    )
  );
  currentUIPathConn$ = createEffect(() =>
    this._actions$.pipe(
      ofType<getCurrentUIPathConn>(EUIPathConnActions.getCurrentUIPathConn),
      switchMap(param => this._rpaBotsService.getConnectionUiPath(param.payload)),
      switchMap((connector: IRpaConnectionUiPath) =>
        of(new getCurrentUIPathConnSuccess(this.addConstants(connector)))
      )
    )
  );
  testUIPathConnection$ = createEffect(() =>
    this._actions$.pipe(
      ofType<TestUIPathConn>(EUIPathConnActions.TestUIPathConn),
      switchMap(param =>
        this._rpaBotsService.testConnectionUiPath(param.payload)
      ),
      switchMap(() => {
        this._rpaBotsService.showSuccessToast('RPA_BOTS.TEST_CONNECTION_SUCCESS');
        return of(new TestUIPathConnSuccess());
      }),
      catchError((error, caught) => {
        this._store.dispatch(new TestUIPathConnSuccess());
        return caught;
      })
    )
  );
  showSuccessToast$ = createEffect(() =>
    this._actions$.pipe(
      ofType<ShowSuccessToast>(EUIPathConnActions.ShowSuccessToast),
      switchMap(() => {
        this.showSuccessToast();
        return of(new ShowSuccessToast());
      })
    )
  );

  showSuccessToast(message?: string) {
    this._translateService
      .get(message || 'GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY')
      .subscribe((messageTranslate: string) => {
        this._toastService.open(messageTranslate, {
          type: 'success',
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'right'
        });
      });
  }

  addConstants(connector: IRpaConnectionUiPath) {
    connector.authUrl = ConstAuthClientCredentials.authUrl;
    connector.grantType = ConstAuthClientCredentials.grantType;
    return connector;
  }

  constructor(
    private _rpaBotsService: RpaBotsService,
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _translateService: TranslateService,
    private _toastService: BzgToastService
  ) {
  }
}
